var map = {
	"./1-WHEEL.png": "1061",
	"./10-WHEEL.png": "6e5c",
	"./15-WHEEL.png": "9e37",
	"./2-WHEEL.png": "9a74",
	"./20-WHEEL.png": "822f",
	"./30-WHEEL.png": "8d75",
	"./40-WHEEL.png": "f697",
	"./5-WHEEL.png": "87d4",
	"./8-WHEEL.png": "d525"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ea10";
module.exports = webpackAsyncContext;